//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DeepLinkRedirect',

  created() {
    const ua = navigator.userAgent || navigator.vendor || window.opera
    const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream
    const isAndroid = /android/i.test(ua)

    // Leer el deep link del query param (ej: ?deepLink=/l/r/141778)
    // Limpiar parámetros fbclid que Instagram agrega automáticamente
    let { deepLink } = this.$route.query
    if (deepLink) {
      const [cleanPath] = deepLink.split('?') // Remover query params (fbclid, etc.)
      deepLink = cleanPath
    }
    const deepLinkUrl = deepLink
      ? `https://app.fanaty.com${deepLink}`
      : 'https://app.fanaty.com'

    if (isAndroid) {
      // En Chrome, intent:// funciona correctamente con browser_fallback_url
      const path = deepLinkUrl.replace(/^https?:\/\//, '')
      const playStoreUrl = 'https://play.google.com/store/apps/details?id=com.fanaty'
      const fallback = encodeURIComponent(playStoreUrl)
      const intentUrl = `intent://${path}#Intent;scheme=https;package=com.fanaty;S.browser_fallback_url=${fallback};end`

      // Si la app está instalada: Chrome/WebView la abre.
      // Si no está instalada: browser_fallback_url redirige al Play Store (en Chrome).
      window.location.href = intentUrl
    } else if (isIOS) {
      // En Safari, intentar abrir la app via Universal Link
      window.location.href = deepLinkUrl

      // Si la app no está instalada, después de 2s ir al App Store
      setTimeout(() => {
        window.location.href = 'itms-apps://apps.apple.com/us/app/fanaty/id1461051554'
      }, 2000)
    } else {
      // Desktop: ir a la web
      window.location.href = 'https://www.fanaty.com/'
    }
  },
}
